// import './components/spinner';
import './components/navigation';
import './components/reveal-cards';
// import { ProductForm } from './components/product-form';
// import { CartDrawer } from './components/cart-drawer';
import './components/product';
// import './components/cart-2';
import Lenis from '@studio-freight/lenis';
var Flickity = require('flickity');
require('flickity-hash');
var Accordion = require('vanilla-js-accordion');
document.addEventListener('DOMContentLoaded', function () {
  const lazyImages = document.querySelectorAll('.lazy-image');
  lazyImages.forEach((img) => {
    // console.log(img);
    img.classList.add('lazy-loaded');
  });

  var wmLogoCarousel = document.querySelectorAll('.wm-carousel');
  if (wmLogoCarousel) {
    wmLogoCarousel.forEach((carousel) => {
      // console.log(carousel);
      let flkty = new Flickity(carousel, {
        draggable: true,
        prevNextButtons: false,
        wrapAround: true,
        contain: false,
        groupCells: false,
        setGallerySize: true,
        pageDots: false,
        cellAlign: 'left',
      });

      const prevButton = carousel.parentElement.querySelector('.previous');
      const nextButton = carousel.parentElement.querySelector('.next');

      prevButton.addEventListener('click', () => {
        flkty.previous();
      });

      nextButton.addEventListener('click', () => {
        flkty.next();
      });

      // Add keyboard navigation
      document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          flkty.previous();
        } else if (event.key === 'ArrowRight') {
          flkty.next();
        }
      });

      // Add event listener for slide change
      flkty.on('change', function (index) {
        // Get the grandparent element
        const grandparent = carousel.parentElement.parentElement;

        if (index > 0) {
          // Add the "slider-started" class if not on the first slide

          prevButton.classList.remove('disabled');
        } else {
          // Remove the "slider-started" class if on the first slide
          grandparent.classList.remove('slider-started');
          prevButton.classList.add('disabled');
        }

        if (index === flkty.slides.length - 1) {
          nextButton.classList.add('disabled');
        } else {
          nextButton.classList.remove('disabled');
        }

        if (currentSlideElement) {
          currentSlideElement.textContent = index + 1;
        }
      });

      // Initialize the state
      flkty.select(0);
    });
  }

  var wmCardCarousel = document.querySelectorAll('.wm-card-carousel');
  if (wmCardCarousel) {
    wmCardCarousel.forEach((carousel) => {
      // console.log(carousel);
      let flkty = new Flickity(carousel, {
        draggable: true,
        prevNextButtons: false,
        wrapAround: false,
        contain: true,
        watchCSS: true,
        groupCells: false,
        setGallerySize: true,
        pageDots: false,
        cellAlign: 'left',
      });

      const prevButton = carousel.parentElement.querySelector('.previous');
      const nextButton = carousel.parentElement.querySelector('.next');

      prevButton.addEventListener('click', () => {
        flkty.previous();
      });

      nextButton.addEventListener('click', () => {
        flkty.next();
      });

      // Add keyboard navigation
      document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          flkty.previous();
        } else if (event.key === 'ArrowRight') {
          flkty.next();
        }
      });

      // Add event listener for slide change
      flkty.on('change', function (index) {
        // Get the grandparent element
        const grandparent = carousel.parentElement.parentElement;

        if (index > 0) {
          // Add the "slider-started" class if not on the first slide

          prevButton.classList.remove('disabled');
        } else {
          // Remove the "slider-started" class if on the first slide
          grandparent.classList.remove('slider-started');
          prevButton.classList.add('disabled');
        }

        if (index === flkty.slides.length - 1) {
          nextButton.classList.add('disabled');
        } else {
          nextButton.classList.remove('disabled');
        }

        // Update current slide index
        // if (currentSlideElement) {
        //   currentSlideElement.textContent = index + 1;
        // }
      });

      // Initialize the state
      flkty.select(0);
    });
  }

  var galleryCarousel = document.querySelectorAll('.gallery-carousel');
  if (galleryCarousel) {
    galleryCarousel.forEach((carousel) => {
      // console.log(carousel);
      let flkty = new Flickity(carousel, {
        draggable: true,
        prevNextButtons: false,
        wrapAround: false,
        contain: true,
        hash: true,
        setGallerySize: false,
        pageDots: false,
        cellAlign: 'center',
      });

      // Add keyboard navigation

      // Add event listener for slide change
    });
  }

  // const productForm = document.getElementById('product-form');

  // if (productForm) {
  //   const container = productForm.parentElement;
  //   // Function to handle sticky behavior
  //   function updateProductForm() {
  //     const containerRect = container.getBoundingClientRect();
  //     const formHeight = productForm.offsetHeight;

  //     if (window.innerWidth > 1023) {
  //       // Check if the bottom of the container is within the viewport
  //       if (containerRect.bottom <= window.innerHeight) {
  //         // If container's bottom is reached, position the form absolutely
  //         productForm.style.position = 'absolute';
  //         productForm.style.bottom = '0';
  //         productForm.style.width = '100%';
  //       } else {
  //         // Keep it fixed at the bottom of the viewport
  //         productForm.style.position = 'fixed';
  //         productForm.style.bottom = '0';
  //         productForm.style.width = '100%';
  //       }
  //     } else {
  //       // Reset to default styles for smaller screens
  //       productForm.style.position = 'fixed';
  //       productForm.style.width = '100%';
  //     }
  //   }

  //   // Add event listeners for scroll and resize
  //   window.addEventListener('scroll', updateProductForm);
  //   window.addEventListener('resize', updateProductForm);

  //   // Initial check on page load
  //   updateProductForm();
  // }

  var faqAccordions = document.querySelectorAll('.faq-accordion');
  var faqAccordion = function () {
    faqAccordions.forEach((i) => {
      // console.log(i);
      let inAccordion = new Accordion(i, {
        item: '.expandable-section',
        target: '.target',
        control: '.target', // in this case the target is also acting as the control
        panel: '.panel',
        allowMultiple: false,
        attribute: 'data-status',
        expanded: 'tab-open',
        contracted: 'tab-closed',
        prefix: 'accordion-',
        transition: 'height .35s',
        setFocus: 'none', // options: none, item, panel, target, control, first
        hashEnabled: true, // use hash in URL to open accordion item
      });
    });
  };

  if (faqAccordions) {
    faqAccordion();
  }

  var wmAccordions = document.querySelectorAll('.wm-accordion');
  var wmAccordion = function () {
    wmAccordions.forEach((i) => {
      // console.log(i);
      let inAccordion = new Accordion(i, {
        item: '.expandable-section',
        target: '.target',
        control: '.target', // in this case the target is also acting as the control
        panel: '.panel',
        allowMultiple: false,
        attribute: 'data-status',
        expanded: 'tab-open',
        contracted: 'tab-closed',
        prefix: 'accordion-',
        transition: 'height .35s',
        setFocus: 'none', // options: none, item, panel, target, control, first
        hashEnabled: true, // use hash in URL to open accordion item
      });
    });
  };

  if (wmAccordions) {
    wmAccordion();
  }
});

// const lenis = new Lenis({
//   smoothWheel: true,
//   smoothTouch: false,
//   wheelEventsTarget: document.documentElement,
// });

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);

// document.addEventListener('DOMContentLoaded', () => {
//   const nestedScrollables = document.querySelectorAll('.nested-scroll');
//   console.log('Found nested scrollable elements:', nestedScrollables);

//   nestedScrollables.forEach((el) => {
//     el.addEventListener(
//       'wheel',
//       (e) => {
//         console.log('Wheel event on nested scroll:', el);
//         e.stopPropagation();
//         lenis.stop();
//         console.log('Lenis stopped');
//       },
//       { passive: false }
//     );

//     el.addEventListener('touchstart', () => {
//       console.log('Touch start on nested scroll:', el);
//       lenis.stop();
//       console.log('Lenis stopped');
//     });
//   });

//   // Re-enable Lenis scrolling when leaving nested scrollable elements
//   nestedScrollables.forEach((el) => {
//     el.addEventListener('mouseleave', () => {
//       console.log('Mouse left nested scroll:', el);
//       lenis.start();
//       console.log('Lenis started');
//     });

//     el.addEventListener('touchend', () => {
//       console.log('Touch ended on nested scroll:', el);
//       lenis.start();
//       console.log('Lenis started');
//     });
//   });
// });

// console.log('Hello World');
